// @flow
import { ApiBase } from 'api/api'
import {
  makeDeleteRequest,
  makePatchRequest,
  makePostRequest,
} from 'api/fetchCalls'
import type { CreateReminderProps, ReminderProps } from 'types/reminders'

export async function createReminder(
  data: CreateReminderProps
): Promise<ReminderProps> {
  return makePostRequest(`${ApiBase}/reminders/`, {
    body: JSON.stringify(data),
  })
}

export async function updateReminder(
  id: string,
  data: CreateReminderProps,
  isGlobal?: boolean
): Promise<ReminderProps> {
  return makePatchRequest(
    `${ApiBase}/reminders/${id}/?global=${isGlobal ? 'true' : 'false'}`,
    {
      body: JSON.stringify(data),
    }
  )
}

export async function deleteReminder(id: string): Promise<void> {
  return makeDeleteRequest(`${ApiBase}/reminders/${id}/`)
}
